export enum SingleSlotDetailsDataHook {
  SERVICE_NAME = 'service-name',
  PRICE_LINE = 'price-line',
  SELECTED_ADDONS = 'selected-addons',
  SELECTED_ADDON_ITEM = 'selected-addon-item',
  SELECTED_RELATED_PRODUCTS = 'selected-related-products',
  SELECTED_RELATED_PRODUCT_ITEM = 'selected-related-product-item',
  MORE_DETAILS = 'more-details',
  MORE_DETAILS_ACCORDION = 'more-details-accordion',
  MORE_DETAILS_BUTTON = 'more-details-button',
  LESS_DETAILS_BUTTON = 'less-details-button',
  PARTICIPANT_DETAILS = 'participant-details',
  PARTICIPANT_NAME = 'participant-details-name',
  PARTICIPANT_VARIANT = 'participant-details-variant',
  PARTICIPANT_PLAN = 'participant-details-plan',
  PARTICIPANT_ADDONS = 'participant-details-addons',
}
